import React, { ReactNode } from 'react'
import { createRoot } from 'react-dom/client'
import { styled } from 'styled-components'
import { ApolloProvider } from '@apollo/client'
import { apolloClient } from '../apollo-client'

const Outer = styled.div`
`

export const mount = (rootElementSelector: string, children: ReactNode) => {
  const init = () => {
    try {
      const rootElement = document.querySelector(rootElementSelector)
      console.log(rootElement, rootElementSelector)
      if(rootElement){
        console.log('Creating root...')
        const root = createRoot(rootElement)
        console.log('Root created, rendering...')
        root.render(
          <ApolloProvider client={apolloClient}>
            <Outer>
              {children}
            </Outer>
          </ApolloProvider>
        )
        console.log('Render called')
      } else {
        console.error('Root element not found:', rootElementSelector)
      }
    } catch (error) {
      console.error('Mount error:', error)
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
}